/**
 * Mock implementation of LogRocket for non-production environments.
 * Logs method calls to console for debugging purposes.
 */
const mockLogRocket = {
  init: (appId: string): void => {
    console.debug('[Mock LogRocket] init called with appId:', appId);
  },

  identify: (userId: string, userTraits?: Record<string, unknown>): void => {
    console.debug('[Mock LogRocket] identify called with:', {
      userId,
      userTraits,
    });
  },

  track: (eventName: string, properties?: Record<string, unknown>): void => {
    console.debug('[Mock LogRocket] track called with:', {
      eventName,
      properties,
    });
  },

  getSessionURL: (callback: (sessionURL: string) => void): void => {
    console.debug('[Mock LogRocket] getSessionURL called');
    callback('mock-session-url');
  },

  captureException: (exception: Error, options?: Record<string, unknown>): void => {
    console.debug('[Mock LogRocket] captureException called with:', {
      exception,
      options,
    });
  },

  captureMessage: (message: string, options?: Record<string, unknown>): void => {
    console.debug('[Mock LogRocket] captureMessage called with:', {
      message,
      options,
    });
  },
};

export default mockLogRocket;
